import { useEffect, useState } from "react";
import { forwardRef } from "react";
import { List } from "antd-mobile";
import instance from "../../util/axios";
import { useHistory } from "react-router-dom";

interface ShortcutsProps {}

export default forwardRef(({}: ShortcutsProps, ref: any) => {
  const [workflowData, setWorkflowData] = useState<
    {
      workflowTemplateId: string;
      formName: string;
    }[]
  >([]);
  useEffect(() => {
    (async () => {
      const resp = await instance.get<any>(`/wf/pageShortcuts/getBaseShortCut`);
      if (resp.data.Status !== "1") return;
      setWorkflowData(resp.data.Data);
    })();
  }, []);
  const history = useHistory();

  return (
    <>
      {workflowData && workflowData.length > 0 && (
        <List>
          <List.Item>表单列表</List.Item>
          {workflowData.map((detail, index) => (
            <>
              <List.Item
                onClick={() => {
                  history.push(
                    `/wf/pageApplication/${detail.workflowTemplateId}/0`
                  );
                }}
              >
                {index + 1}、{detail.formName}
              </List.Item>
            </>
          ))}
        </List>
      )}
    </>
  );
});
